import API from '@/api'

const state = {
	item: {},
	promises: {
		fetch: null,
	},
}

const mutations = {
	set(state, payload) {
		state.item = payload
	},
	setPromise(state, { key, promise }) {
		state.promises[key] = promise
	},
}

const actions = {
	fetch({ commit, state }, payload) {
		commit('set', {})
		let promise = API.getPage(payload).then(data => {
			commit('set', data)
			return data
		})
		commit('setPromise', { key: 'fetch', promise })
		return promise
	},
}

const getters = {}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
